module.exports = __webpack_public_path__ + "static/media/Revisart_27-A.f243316c.jpg";